import { useCallback, useMemo } from 'react';
import { useFetchCampaignsAssociationSettings, hasCampaignsReadAccess } from './useFetchCampaignsAssociationSettings';
import { useCampaignsContext } from '../CampaignsProvider';
import { getIsAssetUngatedForOneToMany } from 'campaigns-lib/utils/campaignGates';
import unescapedText from 'I18n/utils/unescapedText';
export function useCampaignsPlatformEditAction({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  objectId
}) {
  const {
    data: associationSettings,
    loading: associationSettingsLoading
  } = useFetchCampaignsAssociationSettings();
  const {
    showEditCampaignActionModal
  } = useCampaignsContext();
  const isUngatedForOneToMany = useMemo(() => getIsAssetUngatedForOneToMany(objectType), [objectType]);
  const onCampaignEdit = useCallback(() => {
    showEditCampaignActionModal({
      objectType,
      assetId,
      crmIdProperty,
      objectId
    });
  }, [assetId, crmIdProperty, objectId, objectType, showEditCampaignActionModal]);
  return {
    onCampaignEdit,
    editActionText: isUngatedForOneToMany ? unescapedText('campaignSelect.editCampaigns') : unescapedText('campaignSelect.editCampaign'),
    isDisabled: associationSettingsLoading || !associationSettings || !associationSettings[objectType] || !hasCampaignsReadAccess(associationSettings, objectType)
  };
}